import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import '../theme/index.css'
import ElementUI from 'element-ui';
import '@wangeditor/editor/dist/css/style.css'
import '@/style/default.less'

import '@/assets/fonts/iconfont.css'
import "@/assets/fonts/iconfont"

Vue.use(ElementUI);

//全局引入echarts
import * as echarts from 'echarts';
//需要挂载到Vue原型上
Vue.prototype.$echarts = echarts
// 可视化
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

import axios from 'axios'; // 假设你使用 axios 进行 HTTP 请求

// let isAlertVisible = false;  // 弹窗标志位
// // 定义全局函数
// Vue.prototype.$checkUserGroupAndRedirect = function() {
//   if (isAlertVisible) return;
//   // 调用接口获取数据
//   if (this.$store.state.currentState=='通话中') return;
//   axios.get('/view-room/notice')
//     .then(response => {
//       console.log('接口返回的数据:', response.data);
//       const data = response.data;
//       const userId = this.$store.state.userId; 
//       const currentState= this.$store.state.currentState;    
//       console.log('userId',userId);
//       console.log('当前状态：',currentState);
//       console.log('data',data);
//       const matchedItem = data.find(item => item.split('>')[1] == userId.toString());
//       console.log('当：',matchedItem);
      
//       if (matchedItem&&currentState=='未通话') {   //有新的通话，并且当前状态为未通话
//         isAlertVisible = true; // 设置标志位为 true，表示弹窗已显示
//         // 弹窗，并在点击确定后跳转
//         this.$confirm('是否接听电话', '提示', {
//           confirmButtonText: '确定',
//           cancelButtonText: '取消',
//           type: 'warning'  // 可选: 设置弹窗的图标类型
//         }).then(() => {
//           // 用户点击“确定”按钮，跳转到指定路由
//           this.$router.push({
//             path: '/OrganizationalManagement/videoChatview',
//             query: { data: matchedItem }  // 传递找到的项作为参数
//           });
//           clearInterval(this.intervalId);  // 确定接听清除定时器
//         }).catch(() => {
//           // 用户点击“取消”按钮，不执行跳转
//           console.log('用户取消了操作');
//           clearInterval(this.intervalId);  // 清除清除定时器
//         }).finally(() => {
//           // 弹窗关闭后，重置标志位
//           isAlertVisible = false;
//         });
//       } else {
//         // 不满足条件，执行其他逻辑
//         console.log('用户分组不满足条件，不需要跳转');
//       }
//     })
//     .catch(error => {
//       // console.error('接口调用失败:', error);
//     });
// };



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  // created() {
  //   this.$store.dispatch('fetchUserInfo');
  //    // 每秒调用一次 $checkUserGroupAndRedirect
  //    this.intervalId = setInterval(() => {
  //     this.$checkUserGroupAndRedirect();
  //   }, 1000);
  // },
  // beforeDestroy() {
  //   // 组件销毁时清除定时器
  //   clearInterval(this.intervalId);
  // }
}).$mount('#app')
